module.exports = __webpack_public_path__ + "static/media/main3-cards.0dc3593a.png";